/** 현장리포트 카드에 게시된 고객 요청 1건 — 고객용 문장만 싣는다(원문·상태·미반영 요청은 내려오지 않는다). */
export interface ReportRequest {
  requestSnapId: number;
  text: string;
}

/** 표시할 요청 — 문장이 비어 있는 항목은 제외한다. 응답 키가 없어도(구버전 응답) 빈 배열. */
export function visibleRequests(requests: ReportRequest[] | null | undefined): ReportRequest[] {
  return (requests ?? []).filter((r) => r.text && r.text.trim().length > 0);
}
